export const PolicyServiceRequest = 'PolicyServiceRequest';
export const GET_POLICY_SERVICE_REQUEST_DATA =
  'GET_POLICY_SERVICE_REQUEST_DATA';
